import OverlayShell from "./OverlayShell";
import { ActionButton } from "./styles";
import { IMAGES } from "./images";

const Memories = ({ onClose, onTrackButtonClick }) => {
  const handleRedeem = () => {
    onTrackButtonClick?.("redeem_memories", "memories_modal");
  };

  return (
    <OverlayShell title="Lumen" image={IMAGES.stage} onClose={onClose}>
      <div className="section">
        <p>
          Your event photos are ready. Redeem your collection when you want to
          download them.
        </p>
        <ActionButton type="button" onClick={handleRedeem}>
          Redeem photos
        </ActionButton>
      </div>
    </OverlayShell>
  );
};

export default Memories;
